// Vendor libraries
import { EventEmitter, SimpleChanges } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
// Utils / constants
import { abbreviate } from 'NewAngular/utils/string-utils';
// Services
import { ImpersonationService } from 'AccountsApp/ts/services/impersonation.service';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/impersonation.service";
import * as i2 from "@angular/common";
import * as i3 from "../../icon-wrapper/icon-wrapper.component";
import * as i4 from "../../loaders/loading-symbol/loading-symbol.component";
const _c0 = (a0, a1) => ({ "active": a0, "show": a1 });
const _c1 = a0 => ({ "collapse": a0 });
const _c2 = () => [];
const _forTrack0 = ($index, $item) => $item.email;
function ImpersonationMenuComponent_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol");
} }
function ImpersonationMenuComponent_Conditional_5_Conditional_12_For_9_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 22)(1, "input", 23);
    i0.ɵɵlistener("change", function ImpersonationMenuComponent_Conditional_5_Conditional_12_For_9_Template_input_change_1_listener() { const user_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.setCurrentTargetUser(user_r5)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 9);
    i0.ɵɵelementStart(3, "span", 24);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const user_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", (ctx_r1.currentTargetUser == null ? null : ctx_r1.currentTargetUser.email) === user_r5.email);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getUserDisplayName(user_r5, 26), " ");
} }
function ImpersonationMenuComponent_Conditional_5_Conditional_12_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵlistener("mouseleave", function ImpersonationMenuComponent_Conditional_5_Conditional_12_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.setTargetUserMenuExpanded(false)); });
    i0.ɵɵelementStart(1, "div", 15)(2, "div", 16);
    i0.ɵɵelement(3, "input", 17);
    i0.ɵɵelementStart(4, "div", 18)(5, "button", 19);
    i0.ɵɵelement(6, "ycn-icon-wrapper", 20);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelement(7, "div", 21);
    i0.ɵɵrepeaterCreate(8, ImpersonationMenuComponent_Conditional_5_Conditional_12_For_9_Template, 5, 2, "label", 22, _forTrack0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(8);
    i0.ɵɵrepeater(ctx_r1.targetUsers || i0.ɵɵpureFunction0(0, _c2));
} }
function ImpersonationMenuComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "label", 4)(2, "div", 5)(3, "div", 6);
    i0.ɵɵtext(4, "Work as");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "label", 7)(6, "input", 8);
    i0.ɵɵlistener("click", function ImpersonationMenuComponent_Conditional_5_Template_input_click_6_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleWorkAs($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "span", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 10)(9, "div", 11);
    i0.ɵɵlistener("click", function ImpersonationMenuComponent_Conditional_5_Template_div_click_9_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setTargetUserMenuExpanded(!ctx_r1.targetUserMenuExpanded)); });
    i0.ɵɵelementStart(10, "span", 12);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(12, ImpersonationMenuComponent_Conditional_5_Conditional_12_Template, 10, 1, "div", 13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1, !ctx_r1.expanded));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("checked", ctx_r1.workAsActive);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getUserDisplayName(ctx_r1.currentTargetUser, 15), " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.targetUserMenuExpanded ? 12 : -1);
} }
export class ImpersonationMenuComponent {
    constructor(impersonationService) {
        this.impersonationService = impersonationService;
        this.userMenuActive = false;
        this.addErrorMessageHandler = new EventEmitter();
        this.DEFAULT_ERROR_MESSAGE = 'An unknown error occurred. Please try again or contact support.';
        this.loading = false;
        this.expanded = false;
        this.targetUserMenuExpanded = false;
        this.targetUsers = null;
        this.currentTargetUser = null;
        this.workAsActive = false;
        this.workAsActive = window.USER.impersonationState.userImpersonating;
        if (this.workAsActive) {
            this.toggleExpanded();
        }
    }
    ngOnChanges(changes) {
        if (changes.userMenuActive && changes.userMenuActive.currentValue === false) {
            this.targetUserMenuExpanded = false;
        }
    }
    toggleExpanded() {
        // On the first expansion, fetch the target users for the menu. We do this on first
        // expansion rather than on component initialization to avoid making this call on every page.
        if (this.targetUsers === null) {
            this.loading = true;
            this.impersonationService.getImpersonationMenu().subscribe((response) => {
                this.targetUsers = response;
                this.currentTargetUser = response.length > 0 ? response[0] : null;
                this.loading = false;
            });
        }
        this.expanded = !this.expanded;
    }
    toggleWorkAs(toggleEvent) {
        // set loading immediately to prevent multiple clicks
        this.loading = true;
        const input = toggleEvent.target;
        this.workAsActive = input.checked;
        if (!this.workAsActive) {
            // Turning OFF - end impersonation
            this.impersonationService.endImpersonation().subscribe({
                next: () => {
                    // Successfully ended impersonation
                    window.location.reload();
                },
                error: () => {
                    this.loading = false;
                    // If an error occurs while ending impersonation, logout to flush the session
                    window.location.href = `/logout?next=${window.location.pathname}`;
                },
            });
        }
        else {
            // Turning ON - start impersonation
            if (this.currentTargetUser === null) {
                this.addErrorMessageHandler.emit('No user selected for impersonation.');
                this.workAsActive = false;
                input.checked = false;
                this.loading = false;
                return;
            }
            this.impersonateCurrentTargetUser().subscribe({
                next: () => { },
                error: () => {
                    this.workAsActive = false;
                    input.checked = false;
                },
            });
        }
    }
    setTargetUserMenuExpanded(expanded) {
        this.targetUserMenuExpanded = expanded;
    }
    setCurrentTargetUser(user) {
        if (this.currentTargetUser && this.currentTargetUser.email === user.email)
            return;
        const previousTargetUser = this.currentTargetUser;
        this.currentTargetUser = user;
        // if currently impersonating, setting a new target user should trigger request to impersonate new user
        if (this.workAsActive) {
            this.impersonateCurrentTargetUser().subscribe({
                next: () => { },
                error: () => {
                    this.currentTargetUser = previousTargetUser;
                    this.setTargetUserMenuExpanded(false);
                },
            });
        }
    }
    getUserDisplayName(user, maxDisplayNameLength) {
        if (user === null) {
            return '--';
        }
        const firstName = user.first_name;
        const lastName = user.last_name;
        const displayNameLength = firstName.length + lastName.length;
        // abbreviate display name if it exceeds max length
        let displayName;
        if (displayNameLength + 2 >= maxDisplayNameLength) {
            const abbreviationLength = Math.floor((maxDisplayNameLength - 2) / 2);
            displayName = `${abbreviate(lastName, abbreviationLength)}, ${abbreviate(firstName, abbreviationLength)}`;
        }
        else {
            displayName = `${lastName}, ${firstName}`;
        }
        return displayName;
    }
    impersonateCurrentTargetUser() {
        this.loading = true;
        return this.impersonationService.impersonateUser(this.currentTargetUser.email).pipe(tap(() => {
            // Successfully started impersonation
            window.location.reload();
        }), catchError((response) => {
            this.loading = false;
            this.addErrorMessageHandler.emit(response.error.error || this.DEFAULT_ERROR_MESSAGE);
            return throwError(() => response);
        }));
    }
}
ImpersonationMenuComponent.ɵfac = function ImpersonationMenuComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ImpersonationMenuComponent)(i0.ɵɵdirectiveInject(i1.ImpersonationService)); };
ImpersonationMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ImpersonationMenuComponent, selectors: [["ycn-impersonation-menu"]], inputs: { userMenuActive: "userMenuActive" }, outputs: { addErrorMessageHandler: "addErrorMessageHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 5, consts: [[1, "collapse-wrap"], [1, "collapse-header", 3, "click", "ngClass"], [1, "caret"], [1, "theme-dark", "pb-2", 3, "ngClass"], [1, "d-flex", "align-items-center", "mt-1", "mb-10", "pl-20", "pr-20"], [1, "form-label", "form-label-thin"], [1, "text-white", "mr-1"], [1, "custom-control", "custom-switch"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "dropdown", "ml-20", "mr-20"], [1, "btn", "btn-block", "btn-outline", "btn-white", 3, "click"], [1, "d-flex", "align-items-center", "justify-content-between", "w-full", "text-default", "text-nowrap", "caret"], [1, "dropdown-menu", "dropdown-menu-right", "dropdown-menu-with-icons", "width-260", "d-block"], [1, "dropdown-menu", "dropdown-menu-right", "dropdown-menu-with-icons", "width-260", "d-block", 3, "mouseleave"], [1, "ml-12", "mr-12", "pt-1", "pb-1", "theme-dark"], [1, "field-input-group", "field-search", "input-group"], ["placeholder", "Search Team Member", 1, "form-control", "field-input"], [1, "field-input-group-actions"], [1, "btn", "btn-transparent"], ["name", "icon-search"], [1, "dropdown-divider"], [1, "custom-control", "custom-checkbox", "dropdown-item", "custom-checkbox-style1"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "checked"], [1, "custom-control-description", 2, "text-overflow", "'.'", "white-space", "nowrap"]], template: function ImpersonationMenuComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵlistener("click", function ImpersonationMenuComponent_Template_div_click_1_listener() { return ctx.toggleExpanded(); });
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3, "Impersonate");
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(4, ImpersonationMenuComponent_Conditional_4_Template, 1, 0, "ycn-loading-symbol")(5, ImpersonationMenuComponent_Conditional_5_Template, 13, 6, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c0, ctx.expanded, ctx.expanded));
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.loading ? 4 : 5);
    } }, dependencies: [i2.NgClass, i3.IconWrapperComponent, i4.LoadingSymbolComponent], encapsulation: 2 });
